import { DEFAULT_DMS_ROUTES } from '@localstack/constants';
import { ReactElement, useState } from 'react';
import { useAwsEffect, useAwsGetter, useRoutes } from '@localstack/services';
import { Button, Card } from '@mui/material';
import { DMSReplicationInstancesTable, ButtonWithDialog, PageTitle, Dropdown } from '@localstack/ui';

import { DMSProps } from './types';
import { MainTabs } from './components/MainTabs';
import { DMSConfigOptionAlert } from './components/DMSConfigOptionAlert';

export const DMSReplicationInstances = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_DMS_ROUTES,
}: DMSProps): ReactElement => {
  const { goto } = useRoutes();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const {
    data: replicationInstances,
    isLoading,
    mutate,
    error,
  } = useAwsGetter('DMS', 'describeReplicationInstances', [], { clientOverrides });
  const { deleteReplicationInstance } = useAwsEffect('DMS', ['deleteReplicationInstance'], {
    revalidate: ['describeReplicationInstances'],
    clientOverrides,
  });
  const handleRemove = async () => {
    await Promise.all(selectedIds.map(async (id) => deleteReplicationInstance({ ReplicationInstanceArn: id })));
  };
  return (
    <Layout
      title={<PageTitle title="DMS Replication Instances" onMutate={mutate} />}
      tabs={<MainTabs routes={routes} />}
      actions={
        <>
          <Button variant="outlined" onClick={() => goto(routes.RESOURCES_DMS_REPLICATION_INSTANCE_CREATE)}>
            Create Replication Instance
          </Button>
          <Dropdown label="Actions">
            <ButtonWithDialog
              componentType="MenuItem"
              disabled={selectedIds.length === 0 || isLoading}
              dialogTitle={`Delete ${selectedIds.length} Replication Instance(s)?`}
              onClick={handleRemove}
              dialogContent="Selected Replication Instances will be permanently deleted"
            >
              Remove Selected
            </ButtonWithDialog>
          </Dropdown>
        </>
      }
    >
      <DMSConfigOptionAlert error={error} />
      <Card>
        <DMSReplicationInstancesTable
          replicationInstances={replicationInstances?.ReplicationInstances || []}
          onViewReplicationInstance={(id: string) => goto(routes.RESOURCES_DMS_REPLICATION_INSTANCE, { id })}
          loading={isLoading}
          onSelect={setSelectedIds}
        />
      </Card>
    </Layout>
  );
};
